import React from 'react';
import { MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-ink px-3 py-6 sm:px-5" data-id="element-90" data-mp="3gf958x4mo89h">
      <div className="mx-auto max-w-2xl text-center" data-id="element-91" data-mp="3ggtz0kj4bn6a">
        <p className="font-head text-lg uppercase leading-none text-white sm:text-2xl" data-id="element-92" data-mp="32o48c2sn9u2u">
          Special Education Teacher Pro™
        </p>
        <p className="mt-1.5 text-[12px] leading-snug text-white/65" data-id="element-93" data-mp="36pzb7bq84fiq">
          The complete ready-to-use system for professional special education teachers. Because
          supporting different learning needs should not require rebuilding every resource from
          scratch.
        </p>

        <p className="mt-2 flex items-center justify-center gap-1.5 text-[12px] text-white/75" data-id="element-94" data-mp="3ldkeb5n3meqn">
          <MailIcon className="h-3.5 w-3.5 text-mustard" aria-hidden="true" data-id="element-95" data-mp="3qc3zh3tvbmhy" />
          Support:{' '}
          <a href="mailto:kitonline27@gmail.com" className="underline transition-colors duration-150 ease-out hover:text-mustard" data-id="element-96" data-mp="29ydxc2mb78ay">
            kitonline27@gmail.com
          </a>
        </p>

        <p className="mt-2 text-[10px] text-white/50" data-id="element-97" data-mp="3laljxq66apz8">© 2026 Kit Online — All Rights Reserved.</p>
        <p className="mx-auto mt-1 max-w-xl text-[10px] leading-snug text-white/45" data-id="element-98" data-mp="3gbijyk51v9y4">
          The resources provided are intended for professional educational purposes. Teachers remain
          responsible for adapting all materials to their qualifications, students, educational
          objectives, support needs, and learning environment.
        </p>
        <p className="mt-1 text-[10px] text-white/50" data-id="element-99" data-mp="33xchtnnhqqe">
          Terms &amp; Conditions · Privacy Policy · Contact
        </p>
      </div>
    </footer>;
}